/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRoutes.ts                        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/routes";

export class AutogenModelRoutes<RowType extends ModelRow> extends Endpoint<RowType, RowRoutesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRoutes extends ModelRow<RowRoutesFields> {
	constructor(values?: Partial<RowRoutesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRoutesFields {
	accum_dist_um: string;
	accumulated_dist: string;
	accumulated_time: string;
	city_id_1: number;
	city_id_2: number;
	company_id: string;
	direction: string;
	distance_profile: string;
	hazmat_type: string;
	highway: string;
	leg_dest_location: string;
	leg_distance: string;
	leg_distance_um: string;
	line_number: number;
	lookup_type: string;
	method: string;
	notes: string;
	source: string;
	toll_amount: number;
	toll_amount_c: string;
	toll_amount_d: Date;
	toll_amount_n: number;
	toll_amount_r: number;
}

